export default __webpack_public_path__ + "static/media/caret_up.06dad9d3.svg";